import React, {createContext, useReducer, useContext} from 'react'

const UIStateContext = createContext()

const UIDispatchContext = createContext()

const initialUiState = {
  content: null, // the identifier content
  parentPage: null,
  contentProps: {}, // optional props to send to the content action

  detail: {
    show: false,
    type: null,
    options: {},
    loaded: false
  },

  activeFloor: {
    blId: '',
    flId: ''
  },

  homeFloor: {
    blId: '',
    flId: ''
  },

  kioskId: null,

  isKiosk: false
}

const uiReducer = (state, action) => {
  switch (action.type) {
    case 'setContent':
      const {content, parentPage, props} = action.payload
      return {
        ...state,
        content,
        parentPage,
        contentProps: props
      }
    case 'setActiveFloor':
      return {
        ...state,
        activeFloor: action.payload
      }
    case 'setHomeFloor':
      return {
        ...state,
        homeFloor: action.payload
      }
    case 'showSearch':
      return {
        ...state,
        detail: action.payload
      }
    case 'setKioskId':
      return {
        ...state,
        kioskId: action.payload
      }
    case 'setIsKiosk':
      return {
        ...state,
        isKiosk: action.payload
      }
    default: {
      throw new Error(`Unhandled action type: ' ${action.type}`)
    }
  }
}

const UIProvider = ({children}) => {
  const [state, dispatch] = useReducer(uiReducer, initialUiState)

  return (
    <UIStateContext.Provider value={state}>
      <UIDispatchContext.Provider value={dispatch}>
        {children}
      </UIDispatchContext.Provider>
    </UIStateContext.Provider>
  )
}

const useUIState = () => {
  const context = useContext(UIStateContext)
  if (context === undefined) {
    throw new Error('useUIState must be used within a UIProvider')
  }
  return context
}

const useUIDispatch = () => {
  const context = useContext(UIDispatchContext)
  if (context === undefined) {
    throw new Error('useUIDispatch must be used within a UIProvider')
  }

  return context
}

export {UIProvider, useUIState, useUIDispatch}
